/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetInspectionDto,
    GetInspectionDtoFromJSON,
    GetInspectionDtoFromJSONTyped,
    GetInspectionDtoToJSON,
    GetProductTypeDto,
    GetProductTypeDtoFromJSON,
    GetProductTypeDtoFromJSONTyped,
    GetProductTypeDtoToJSON,
    GetSampleExamDto,
    GetSampleExamDtoFromJSON,
    GetSampleExamDtoFromJSONTyped,
    GetSampleExamDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetInspectedProductDto
 */
export interface GetInspectedProductDto {
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    subtype: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    quantity: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    technicalSpecification: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    checkMarking: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    checkDeclaration: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    checkDocumentation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    checkManual: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    checkVolatileOrganicCompounds: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    analyzisInProgress: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    misstatementFound: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    findings: string;
    /**
     * 
     * @type {GetSampleExamDto}
     * @memberof GetInspectedProductDto
     */
    sampleExam: GetSampleExamDto;
    /**
     * 
     * @type {GetProductTypeDto}
     * @memberof GetInspectedProductDto
     */
    productType: GetProductTypeDto;
    /**
     * 
     * @type {GetInspectionDto}
     * @memberof GetInspectedProductDto
     */
    inspection: GetInspectionDto;
    /**
     * 
     * @type {number}
     * @memberof GetInspectedProductDto
     */
    orderNo: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    productMissing: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    purpose: string;
    /**
     * 
     * @type {string}
     * @memberof GetInspectedProductDto
     */
    placeOfProduction: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    placeOfProductionNA: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetInspectedProductDto
     */
    yearOfProduction: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetInspectedProductDto
     */
    yearOfProductionNA: boolean;
}

export function GetInspectedProductDtoFromJSON(json: any): GetInspectedProductDto {
    return GetInspectedProductDtoFromJSONTyped(json, false);
}

export function GetInspectedProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInspectedProductDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subtype': json['subtype'],
        'quantity': json['quantity'],
        'technicalSpecification': json['technicalSpecification'],
        'checkMarking': json['checkMarking'],
        'checkDeclaration': json['checkDeclaration'],
        'checkDocumentation': json['checkDocumentation'],
        'checkManual': json['checkManual'],
        'checkVolatileOrganicCompounds': json['checkVolatileOrganicCompounds'],
        'analyzisInProgress': json['analyzisInProgress'],
        'misstatementFound': json['misstatementFound'],
        'description': json['description'],
        'findings': json['findings'],
        'sampleExam': GetSampleExamDtoFromJSON(json['sampleExam']),
        'productType': GetProductTypeDtoFromJSON(json['productType']),
        'inspection': GetInspectionDtoFromJSON(json['inspection']),
        'orderNo': json['orderNo'],
        'productMissing': json['productMissing'],
        'purpose': json['purpose'],
        'placeOfProduction': json['placeOfProduction'],
        'placeOfProductionNA': json['placeOfProductionNA'],
        'yearOfProduction': json['yearOfProduction'],
        'yearOfProductionNA': json['yearOfProductionNA'],
    };
}

export function GetInspectedProductDtoToJSON(value?: GetInspectedProductDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subtype': value.subtype,
        'quantity': value.quantity,
        'technicalSpecification': value.technicalSpecification,
        'checkMarking': value.checkMarking,
        'checkDeclaration': value.checkDeclaration,
        'checkDocumentation': value.checkDocumentation,
        'checkManual': value.checkManual,
        'checkVolatileOrganicCompounds': value.checkVolatileOrganicCompounds,
        'analyzisInProgress': value.analyzisInProgress,
        'misstatementFound': value.misstatementFound,
        'description': value.description,
        'findings': value.findings,
        'sampleExam': GetSampleExamDtoToJSON(value.sampleExam),
        'productType': GetProductTypeDtoToJSON(value.productType),
        'inspection': GetInspectionDtoToJSON(value.inspection),
        'orderNo': value.orderNo,
        'productMissing': value.productMissing,
        'purpose': value.purpose,
        'placeOfProduction': value.placeOfProduction,
        'placeOfProductionNA': value.placeOfProductionNA,
        'yearOfProduction': value.yearOfProduction,
        'yearOfProductionNA': value.yearOfProductionNA,
    };
}


